import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  className?: string;
}
export function Button({
  children,
  href,
  onClick,
  fullWidth,
  className = ''
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-teal-600 rounded-lg hover:bg-teal-700 transition-all duration-200 shadow-lg hover:shadow-xl ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    // Check if it's an external link (starts with http)
    const isExternal = href.startsWith('http');
    return <a href={href} className={baseClasses} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} data-id="element-50">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={baseClasses} data-id="element-51">
      {children}
    </button>;
}